import {makeAutoObservable, observable} from 'mobx'
import {ApiHelp, HelpNode} from '@api/api-help'
import {DragData} from '@common/drag-data'
import {createUseStore} from '@containers/hooks'
import {ScriptsStore} from './scripts-store'

interface State {
  objects: HelpNode[]
  expandedName: string
  hovered: HelpNode
}

export class ScriptsApiNavStore {
  state: State

  constructor(public store: ScriptsStore) {
    this.state = {
      objects: ApiHelp.getAllObjects(),
      expandedName: undefined,
      hovered: undefined
    }

    makeAutoObservable(
      this,
      {
        state: observable.shallow,
        store: false
      },
      {autoBind: true}
    )
  }

  toggle(name: string): void {
    this.state.expandedName =
      this.state.expandedName === name ? undefined : name
  }

  toggleHint(node: HelpNode): void {
    this.state.hovered = node
  }

  dragStart(node: HelpNode, e: React.DragEvent): void {
    DragData.set(e, {type: 'api-code', code: node.code})
  }

  onDrop(event: React.DragEvent): void {
    if (
      !this.store.globalState.monaco ||
      !this.store.globalState.codeStore.state.openedTab
    ) {
      return
    }
    const data = DragData.get()
    if (data.type === 'api-code') {
      event.preventDefault()
      this.store.globalState.monaco.insertAtCursor(data.code)
    }
  }

  onDragOver(event: React.DragEvent): void {
    if (
      !this.store.globalState.monaco ||
      !this.store.globalState.codeStore.state.openedTab
    ) {
      return
    }
    if (DragData.get().type === 'api-code') {
      event.preventDefault()
      DragData.setEffect(event, 'copy')
    }
  }

  onDragLeave(event: React.DragEvent): void {
    if (
      !this.store.globalState.monaco ||
      !this.store.globalState.codeStore.state.openedTab
    ) {
      return
    }
    if (DragData.get().type === 'api-code') {
      event.preventDefault()
      DragData.setEffect(event, undefined)
    }
  }
}

export const [ScriptsApiNavContext, useScriptsApiNavStore] =
  createUseStore(ScriptsApiNavStore)
